import dayjs from 'dayjs';
import { DEFAULT_ORG_ADMIN_JOB_TITLE } from 'config/const';
import { CardType, DisbursementMethod, EmployeeType, IEmployee, IHoldbackFixed, IHoldbackPercent, IPayoutStateByDate } from 'types';
import { centsToDollars } from './currency';
import { calculateHoldbackValue } from './payout';

export const getPaymentTypeIcon = (cardType: CardType | undefined) => {
  if (cardType?.toLowerCase() === CardType.AMERICAN_EXPRESS.toLowerCase()) {
    return 'AmericanExpress';
  }
  if (cardType?.toLowerCase() === CardType.DISCOVER.toLowerCase()) {
    return 'DiscoverCard';
  }
  if (cardType?.toLowerCase() === CardType.MASTER_CARD.toLowerCase()) {
    return 'Mastercard';
  }
  if (cardType?.toLowerCase() === CardType.VISA.toLowerCase()) {
    return 'Visa';
  }
  return 'Payment';
};

export const convertEmployeeToPayee = (employee: IEmployee, siteId: string, siteHoldbacks: IHoldbackFixed | IHoldbackPercent) => {
  const selectedEmployeeSite = employee.sites?.find((s) => s.id === siteId);

  // set job title to org admin
  if (employee.type === EmployeeType.ADMIN && selectedEmployeeSite) {
    selectedEmployeeSite.job = { title: DEFAULT_ORG_ADMIN_JOB_TITLE };
  }
  return {
    ...employee,
    job: selectedEmployeeSite?.job,
    disbursementMethod: selectedEmployeeSite?.disbursementMethod,
    holdbackAmount: calculateHoldbackValue(selectedEmployeeSite?.disbursementMethod || DisbursementMethod.INSTANT, siteHoldbacks, 0),
  };
};

export const paymentStatToChartPoints = (paymentStats: IPayoutStateByDate[]) => {
  if (paymentStats.length > 31) {
    // render chart-data as monthly totals when date-range is greater than 31 days
    const paymentStatsByMonth = paymentStats.reduce((acc, stat): Array<{ x: string; y: number; value: string; instant: number; payroll: number }> => {
      const monthIndex = acc.findIndex((chartPoint) => chartPoint.x === dayjs(stat.date).format('MMM YYYY'));

      if (monthIndex >= 0) {
        // add to existing monthly chart-data if it exists...
        acc[monthIndex] = {
          ...acc[monthIndex],
          y: acc[monthIndex].y + centsToDollars(stat.net),
          value: `${+acc[monthIndex].value.split(' ')[0] + stat.count} payments`,
          instant: acc[monthIndex].instant + centsToDollars(stat.instant),
          payroll: acc[monthIndex].payroll + centsToDollars(stat.payroll),
        };
      } else {
        // ...otherwise create new monthly instance
        acc.push({
          x: dayjs(stat.date).format('MMM YYYY'),
          y: centsToDollars(stat.net),
          value: `${stat.count} payments`,
          instant: centsToDollars(stat.instant),
          payroll: centsToDollars(stat.payroll),
        });
      }

      return acc;
    }, []);

    return paymentStatsByMonth;
  }

  return paymentStats.map((paymentStat) => ({
    x: dayjs(paymentStat.date).format('MM/DD'),
    y: centsToDollars(paymentStat.net),
    value: `${paymentStat.count} payments`,
    instant: centsToDollars(paymentStat.instant),
    payroll: centsToDollars(paymentStat.payroll),
  }));
};
